/* Диалог «В тестовый канал». Сводка повторяет посадку блока «Что будет подписано» диалога
   утверждения: одно и то же «вот что уйдёт в Telegram» обязано выглядеть одинаково в обоих
   местах, где человек отпускает пост. Ни одного цвета литералом. */

.summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--bg-alt);
  border: 1px solid var(--border);
  border-radius: var(--r-ctl);
  padding: 14px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.summaryHead {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Ход — три шага сверху вниз. Текущий отмечен дышащей точкой, пройденный — галкой: «сколько
   прошли» читается без чтения слов. */
.steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.step {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: var(--muted);
}

.step[data-state="done"] {
  color: var(--ink-2);
}

.step[data-state="current"] {
  color: var(--ink);
  font-weight: 600;
}

.mark {
  flex: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--border);
  background: var(--white);
}

.step[data-state="done"] .mark {
  border-color: var(--green-ink);
  color: var(--green-ink);
}

.step[data-state="current"] .mark {
  border-color: var(--violet);
  background: var(--violet-bg);
  animation: stepBreath 1.4s var(--ease) infinite alternate;
}

@keyframes stepBreath {
  from {
    box-shadow: 0 0 0 0 var(--violet-bg-2);
  }
  to {
    box-shadow: 0 0 0 4px var(--violet-bg-2);
  }
}

@media (prefers-reduced-motion: reduce) {
  .step[data-state="current"] .mark {
    animation: none;
  }
}
